import { render, staticRenderFns } from "./RadioButtons.form.vue?vue&type=template&id=4a4fbab8&scoped=true&"
import script from "./RadioButtons.form.vue?vue&type=script&lang=js&"
export * from "./RadioButtons.form.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtons.form.vue?vue&type=style&index=0&id=4a4fbab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4fbab8",
  null
  
)

export default component.exports